import { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { PageHero } from "@/components/common";
import useTitle from "@/lib/useTitle";
import { fileUrl } from "@/lib/api";

export function OrgMark({ org, size = "h-14 w-14 text-xl" }) {
  return org.logo
    ? <img src={fileUrl(org.logo)} alt={`Logótipo de ${org.name}`} className={`${size} object-contain`} />
    : <span className={`${size} bg-[var(--ink)] text-white grid place-items-center font-display font-black uppercase`} aria-hidden>{org.name.split(/\s+/)[0].slice(0, 4)}</span>;
}

export default function Organizacoes() {
  useTitle("Organizações");
  const { data } = useSite();
  const [q, setQ] = useState("");
  const [area, setArea] = useState("");
  const areas = [...new Set(data.organizations.map((o) => o.area).filter(Boolean))];
  const n = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  const list = data.organizations.filter((o) => (!area || o.area === area) && n(o.name).includes(n(q)));
  const shared = data.organizations.reduce((m, o) => (o.logo ? { ...m, [o.logo]: (m[o.logo] || 0) + 1 } : m), {});
  return (
    <>
      <PageHero eyebrow="Expositores e organizações" title="Quem faz a Feira" tone="#7c3aed" image="/img/gathering.jpg">Conheça as organizações participantes, as suas áreas de intervenção e as atividades que dinamizam.</PageHero>
      <div className="container-x py-10">
        <div className="grid gap-3 sm:grid-cols-[1fr_280px]">
          <label className="relative">
            <span className="sr-only">Pesquisar por nome</span>
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-500" aria-hidden />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar por nome" className="h-12 w-full rounded-xl border border-black/15 bg-white pl-12 pr-4" data-testid="orgs-search-input" />
          </label>
          <label><span className="sr-only">Área de intervenção</span>
            <select value={area} onChange={(e) => setArea(e.target.value)} className="h-12 w-full rounded-xl border border-black/15 bg-white px-3" data-testid="orgs-area-filter"><option value="">Todas as áreas</option>{areas.map((a) => <option key={a}>{a}</option>)}</select>
          </label>
        </div>
        <p className="mt-6 text-sm text-slate-700" aria-live="polite" data-testid="orgs-count">{list.length} organizaç{list.length === 1 ? "ão" : "ões"}</p>
        <ul className="mt-6 grid gap-x-6 gap-y-2 grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {list.map((o) => (
            <li key={o.id}>
              <Link to={`/organizacoes/${o.slug}`} aria-label={o.name} title={o.name} className="group flex flex-col items-center justify-center gap-1 h-28 sm:h-40 px-2 sm:px-4" data-testid={`org-card-${o.slug}`}>
                <OrgMark org={o} size={`${shared[o.logo] > 1 ? "h-14 sm:h-20" : "h-20 sm:h-28"} w-full text-xl sm:text-3xl`} />
                {shared[o.logo] > 1 && <span className="text-xs sm:text-sm font-semibold text-center leading-tight text-[var(--ink)]" data-testid={`org-card-name-${o.slug}`}>{o.name.replace(" — Hospital de Egas Moniz", "")}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
